import { Box, Skeleton, Typography } from "@mui/material";
import { AppIconsCart } from "../../components/AppIcons";
import { PageTitle } from "./BasketPage.styles";
import { Basket } from "../../../explorer/types";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import { useTableLayoutClasses } from "../../components/PartsList/TableLayout/TableLayout.style";
import useCurrentSite from "../../hook/useCurrentSite";
import AppLogo from "../../components/AppLayout/AppHeader/AppLogo/AppLogo";
import { useUserInfo } from "../../../explorer/hooks/useUserInfo";

type TBasketHeader = {
    basket?: Basket;
};
const BasketHeader = (props: TBasketHeader) => {
    const { basket } = props;
    const { t } = useTranslation();
    const [currentSite] = useCurrentSite();
    const [user] = useUserInfo();
    const classes = useTableLayoutClasses();

  return (
    <PageTitle>
      <Box
        sx={[classes.showOnPrint, { display: "flex", flexDirection: "column" }]}
      >
        <Box>
          <Typography>
            {user.firstName} {user.lastName}<br/>{user.userName}
          </Typography>
          <Typography>{currentSite.customerSiteCode}</Typography>
          <Typography>{currentSite.customerSiteName}</Typography>
          <Typography>
            {currentSite.address} - {currentSite.city},{currentSite.zipCode} (
            {currentSite.country})
          </Typography>
        </Box>
      </Box>
      {basket ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start !important",
          }}
        >
          <Box sx={[classes.showOnPrint, {}]}>
            <AppLogo useLightLogo={false} />
          </Box>

                    <Box sx={{ display: "flex", alignItem: "center" }}>
                        <AppIconsCart />
                        {`${t("basket.title")} ${basket.name}`}
                    </Box>
                </Box>
            ) : (
                <Skeleton />
            )}
        </PageTitle>
    );
};

export default BasketHeader;
